import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function ECOTanzania() {
  return (
    <div className="art-page">
      <SEO
        title="Cookstove Monitoring — E+CO Tanzania"
        description="In 2010, CIRCODU extended monitoring expertise beyond Uganda to Tanzania, conducting Kitchen Performance Tests for Envirofit wood stoves and SEECO charcoal stoves across Arusha, Mwanza, and Dar es Salaam."
        keywords="cookstove monitoring, Tanzania, E+CO, Envirofit, SEECO, Kitchen Performance Tests, Arusha, Mwanza, Dar es Salaam, clean cooking, carbon offset, CIRCODU, cookstove monitoring Tanzania, E+CO cookstove programme Tanzania, Envirofit stoves Tanzania, SEECO stoves Tanzania, Kitchen Performance Tests Tanzania, Arusha cookstove monitoring, Mwanza cookstove monitoring, Dar es Salaam cookstove monitoring"
        url="/Monitoring-for-International-Energy-Investment-Organisation-E+CO-Cookstove-Programme-Tanzania"
        datePublished="2010-12-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Cookstove Monitoring — E+CO Tanzania
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 01, 2010
            </div>
            <h1 className="art-title">
              Monitoring for International Energy Investment Organisation (E+CO)
              Cookstove Programme — Tanzania
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In 2010, CIRCODU extended its monitoring expertise beyond
                Uganda's borders for the first time, travelling to Tanzania to
                conduct cookstove field assessments in partnership with{" "}
                <strong>Berkeley Air Monitoring Group</strong> and{" "}
                <strong>Envicon of Tanzania</strong>. The assignment was
                commissioned under the{" "}
                <strong>E+CO (Energy and Capital)</strong> cookstove programme —
                an organisation that invested in clean energy enterprises across
                the developing world. The work involved kitchen surveys and
                Kitchen Performance Tests for{" "}
                <strong>Envirofit wood stoves</strong> and{" "}
                <strong>SEECO charcoal stoves</strong> in three Tanzanian
                cities: Arusha, Mwanza, and Dar es Salaam.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                Working alongside the Tanzanian partner organisation Envicon,
                CIRCODU applied its established KPT and kitchen survey
                methodologies to assess the real-world performance of two
                cookstove technologies under local cooking conditions. The
                multi-city scope required careful adaptation of protocols to
                different fuel types, household configurations, and cooking
                cultures across Tanzania's northern highlands (Arusha), the
                lakeside city of Mwanza on Lake Victoria, and the commercial
                capital Dar es Salaam on the Indian Ocean coast.
              </p>
              <p>
                Each city presented distinct cooking norms and fuel availability
                patterns — from the charcoal-dominated kitchens of Dar es Salaam
                to the more varied fuel mix of the interior — requiring CIRCODU
                to demonstrate the adaptability of its monitoring approach
                across diverse East African contexts.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                This assignment marked an early and important step in CIRCODU's
                evolution from a Uganda-focused organisation into a{" "}
                <strong>regional monitoring capability</strong>. The experience
                of conducting credible, internationally recognised assessments
                in a different East African context validated CIRCODU's
                methodologies and built the cross-border expertise that would
                later underpin its identity as a regional leader in cookstove
                testing and monitoring.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's regional monitoring
                capabilities, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
